import React from "react";
import { func, string, arrayOf } from "prop-types";
import Button from "pages/_components/Button";
import { WithContext as ReactTags } from "react-tag-input";
import { isIOS } from "react-device-detect";

const FilterTags = ({ openSideBarFilters, tags, handleDelete, handleCleanFilters }) => (
    <div className="tags-filter">
        <Button
            image={isIOS ? "images/figma/icon/filter-primary.svg" : "images/figma/icon/filter.svg"}
            onClick={openSideBarFilters}
            label="global.filter"
            className="btn btn-link open-filters"
            block={false}
        />
        {!!tags.length && (
            <>
                <ReactTags
                    autofocus={false}
                    tags={tags}
                    handleDelete={handleDelete}
                    allowDragDrop={false}
                    placeholder=""
                    inputProps={{
                        disabled: true,
                        autocomplete: "off",
                    }}
                    classNames={{
                        tags: "tagsClass",
                        selected: "selectedClass",
                        tag: "tagClass",
                        remove: "removeClass",
                    }}
                />
                <Button
                    image="images/figma/icon/clear-filter.svg"
                    onClick={handleCleanFilters}
                    label="debin.clean.filters"
                    className="btn btn-link clear-filters"
                    block={false}
                    icon=""
                />
            </>
        )}
    </div>
);

FilterTags.propTypes = {
    openSideBarFilters: func.isRequired,
    tags: arrayOf(string).isRequired,
    handleDelete: func.isRequired,
    handleCleanFilters: func.isRequired,
};

export default FilterTags;
